<template>
  <div class="nav-footer-mobile">
    <div class="logo-box">
      <img src="../assets/底端导航/redtea_logo_en.png" />
      <!-- <img src="../assets/底端导航/红茶移动logo (1).png" /> -->
    </div>
    <div class="footer-menu">
      <Menu :width="'200'">
        <Submenu name="3">
          <template slot="title">
            <img src="../assets/底端导航/标题.svg" class="menu-img" />
            {{ $t("nav.Consumers") }}
          </template>
          <MenuItem name="3-5">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaGo#iosEsim"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.iosEsim") }}</router-link
            >
          </MenuItem>
          <MenuItem name="3-1">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaGo#Android"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Android") }}</router-link
            >
          </MenuItem>
          <!--          <MenuItem name="3-2">-->
          <!--            <div class="circle-icon"></div>-->
          <!--            <router-link-->
          <!--              to="/RedteaGo#iPhone"-->
          <!--              style="color: rgba(255, 255, 255, 1)"-->
          <!--              >{{ $t('nav.iPhone') }}</router-link-->
          <!--            >-->
          <!--          </MenuItem>-->
          <!--          <MenuItem name="3-3">-->
          <!--            <div class="circle-icon"></div>-->
          <!--            <a-->
          <!--              href="https://esim.redteago.com/"-->
          <!--              style="color: rgba(255, 255, 255, 1)"-->
          <!--              >{{ $t("nav.eSIMDataPlan") }}</a-->
          <!--            >-->
          <!--          </MenuItem>-->
          <!--          <MenuItem name="3-4">-->
          <!--            <div class="circle-icon"></div>-->
          <!--            <router-link-->
          <!--              to="/RedteaGo#SIMCard"-->
          <!--              style="color: rgba(255, 255, 255, 1)"-->
          <!--              >{{ $t("nav.GlobalSIM") }}</router-link-->
          <!--            >-->
          <!--          </MenuItem>-->
        </Submenu>
        <Submenu name="2">
          <template slot="title">
            <img src="../assets/底端导航/标题.svg" class="menu-img" />
            {{ $t("nav.M2M") }}
          </template>
          <MenuItem name="2-1">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaReady#FWA"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Fixed") }}</router-link
            >
          </MenuItem>
          <MenuItem name="2-2">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaReady#Automotive"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Automotive") }}</router-link
            >
          </MenuItem>
          <MenuItem name="2-3">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaReady#Handheld"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Handheld") }}</router-link
            >
          </MenuItem>
          <MenuItem name="2-4">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaReady#Logistics"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Logistcs") }}</router-link
            >
          </MenuItem>
          <MenuItem name="2-5">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaReady#Utilities"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Utilities") }}</router-link
            >
          </MenuItem>
          <MenuItem name="2-6">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaReady#Wearable"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Dongle") }}</router-link
            >
          </MenuItem>
        </Submenu>
        <!-- <MenuItem name="6">
          <img src="../assets/底端导航/标题.svg" class="menu-img" />
          <router-link to="/RedteaSIM" style="color:rgba(255, 255, 255, 0.6);">{{$t('nav.eSIMDes')}}</router-link>
        </MenuItem> -->
        <Submenu name="6">
          <template slot="title">
            <img src="../assets/底端导航/标题.svg" class="menu-img" />
            {{ $t("nav.eSIMDes") }}
          </template>
          <MenuItem name="6-1">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaSIM#cost"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.cost") }}</router-link
            >
          </MenuItem>
          <MenuItem name="6-2">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaSIM#Improve"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Improve") }}</router-link
            >
          </MenuItem>
          <MenuItem name="6-3">
            <div class="circle-icon"></div>
            <router-link
              to="/RedteaSIM#exp"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.exp") }}</router-link
            >
          </MenuItem>
        </Submenu>
        <Submenu name="7">
          <template slot="title">
            <img src="../assets/底端导航/标题.svg" class="menu-img" />
            {{ $t("nav.eSimPlus") }}
          </template>
          <MenuItem name="7-1">
            <div class="circle-icon"></div>
            <router-link
              to="/esim-plus#esimPlusDpPlus"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.DPPlus") }}</router-link
            >
          </MenuItem>
          <MenuItem name="7-2">
            <div class="circle-icon"></div>
            <router-link
              to="/esim-plus#esimPlusES"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.ES") }}</router-link
            >
          </MenuItem>
          <MenuItem name="7-3">
            <div class="circle-icon"></div>
            <router-link
              to="/esim-plus#esimPlusRedteaGOAPP"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.RedteaGOAPP") }}</router-link
            >
          </MenuItem>
        </Submenu>
        <Submenu name="1">
          <template slot="title">
            <img src="../assets/底端导航/标题.svg" class="menu-img" />
            {{ $t("nav.CaaS") }}
          </template>
          <MenuItem name="1-1">
            <div class="circle-icon"></div>
            <router-link
              to="/CaaS#Global"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Global") }}</router-link
            >
          </MenuItem>
          <MenuItem name="1-2">
            <div class="circle-icon"></div>
            <router-link
              to="/CaaS#Embedded"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Embedded") }}</router-link
            >
          </MenuItem>
          <MenuItem name="1-3">
            <div class="circle-icon"></div>
            <router-link
              to="/CaaS#Open"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Open") }}</router-link
            >
          </MenuItem>
          <MenuItem name="1-4">
            <div class="circle-icon"></div>
            <router-link
              to="/CaaS#Smart"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Smart") }}</router-link
            >
          </MenuItem>
        </Submenu>
        <Submenu name="4">
          <template slot="title">
            <img src="../assets/底端导航/标题.svg" class="menu-img" />
            {{ $t("nav.Resources") }}
          </template>
          <MenuItem name="4-1">
            <div class="circle-icon"></div>
            <router-link
              to="/Resources#News"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.NewsEvents") }}</router-link
            >
          </MenuItem>
          <MenuItem name="4-2">
            <div class="circle-icon"></div>
            <router-link
              to="/Resources#Industry"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.IndustryReports") }}</router-link
            >
          </MenuItem>
          <MenuItem name="4-3">
            <div class="circle-icon"></div>
            <router-link
              to="/Resources#Insights"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Insights") }}</router-link
            >
          </MenuItem>
          <MenuItem name="4-4">
            <div class="circle-icon"></div>
            <router-link
              to="/Resources#Terms"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.TermsJargons") }}</router-link
            >
          </MenuItem>
          <MenuItem name="4-5">
            <div class="circle-icon"></div>
            <router-link
              to="/Resources#FAQ"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.FAQ") }}</router-link
            >
          </MenuItem>
        </Submenu>

        <Submenu name="5">
          <template slot="title">
            <img src="../assets/底端导航/标题.svg" class="menu-img" />
            {{ $t("nav.AboutUs") }}
          </template>
          <MenuItem name="5-1">
            <div class="circle-icon"></div>
            <router-link
              to="/about#Overview"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Overview") }}</router-link
            >
          </MenuItem>
          <MenuItem name="5-2">
            <div class="circle-icon"></div>
            <router-link
              to="/about#Mission"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Mission") }}</router-link
            >
          </MenuItem>
          <MenuItem name="5-3">
            <div class="circle-icon"></div>
            <router-link
              to="/about#Vision"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Vision") }}</router-link
            >
          </MenuItem>
          <MenuItem name="5-4">
            <div class="circle-icon"></div>
            <router-link
              to="/about#Values"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Values") }}</router-link
            >
          </MenuItem>
          <MenuItem name="5-5">
            <div class="circle-icon"></div>
            <router-link
              to="/about#Recognition"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Recognition") }}</router-link
            >
          </MenuItem>
          <MenuItem name="5-6">
            <div class="circle-icon"></div>
            <router-link
              to="/about#Careers"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Careers") }}</router-link
            >
          </MenuItem>
          <MenuItem name="5-7">
            <div class="circle-icon"></div>
            <router-link
              to="/about#Team"
              style="color: rgba(255, 255, 255, 1)"
              >{{ $t("nav.Team") }}</router-link
            >
          </MenuItem>
        </Submenu>
      </Menu>
    </div>
    <div class="footer-follow">
      <div class="follow-title">{{ $t("follow") }}:</div>
      <div class="footer-follow">
        <Poptip trigger="hover" placement="top-start">
          <img
            src="../assets/底端导航/微信.svg"
            style="margin-left: -0.1rem; width: 0.58rem"
          />
          <div slot="content">
            <img
              src="../assets/web/红茶移动微信二维码.jpg"
              style="width: 150px"
            />
          </div>
        </Poptip>
        <a href="https://www.facebook.com/redteamobile" target="_Blank">
          <img
            src="../assets/底端导航/Facebook.svg"
            style="margin-left: -0.08rem"
          />
        </a>
        <a href="https://twitter.com/redteamobile" target="_Blank">
          <img src="../assets/底端导航/Twitter.svg" />
        </a>
        <a href="https://www.linkedin.com/company/13216053/" target="_Blank">
          <img src="../assets/底端导航/Linkedin.svg" />
        </a>
        <a
          href="https://www.zhihu.com/org/redteamobile/activities"
          target="_Blank"
        >
          <img src="../assets/底端导航/知乎.svg" />
        </a>
      </div>
    </div>
    <div class="policy">{{ $t("nav.copyRight") }}</div>
    <a class="icp-link" href="http://beian.miit.gov.cn" target="_blank"
      >粤ICP备20020278号</a
    >
  </div>
</template>
<script>
export default {
  name: "nav-footer-mobile",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less">
.nav-footer-mobile {
  background-color: #182456;
  color: rgba(255, 255, 255, 1);
  padding: 0.3rem 0 0.2rem 0;
  .logo-box {
    img {
      width: 1.3rem;
    }
  }
  .menu-img {
    width: 0.09rem;
    margin-right: 0.1rem;
  }
  .footer-menu {
    margin: 0.2rem 0 0.3rem 0;
    text-align: left;
    .circle-icon {
      width: 0.05rem;
      height: 0.05rem;
      border-radius: 50%;
      background-color: #fff;
      display: inline-block;
      line-height: 0.14rem;
      margin: 0 0.1rem 0.01rem 0.2rem;
    }
  }

  .footer-follow {
    padding-left: 0.1rem;
    text-align: left;
    margin-top: 0.3rem;
    margin-bottom: 0.1rem;
    .follow-title {
      font-size: 0.14rem;
      margin-bottom: 0.2rem;
      margin-left: 0.1rem;
    }
    img {
      width: 0.48rem;
      min-width: 50px;
    }
  }
  .policy {
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    text-align: center;
    font-size: 0.12rem;
    letter-spacing: 1px;
    font-family: "Poppins-ExtraLight";
    margin-top: 0.2rem;
  }
  .icp-link {
    color: #fff;
    font-family: "Poppins-ExtraLight";
  }
  .ivu-menu {
    background: none !important;
  }
  .ivu-menu-light.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: none !important;
    color: rgba(255, 255, 255, 1) !important;
    font-family: "Poppins-Light";
  }
  .ivu-menu-item {
    color: rgba(255, 255, 255, 1) !important;
    font-family: "Poppins-Light";
  }
  .ivu-menu-vertical .ivu-menu-item:hover,
  .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: rgba(255, 255, 255, 0.6) !important;
  }
  .ivu-menu-submenu-title {
    color: rgba(255, 255, 255, 0.6) !important;
    font-size: 0.14rem;
    font-family: "Poppins-Regular";
  }
}
</style>